// services/providers.js
import axiosInstance from './axiosInstance';

const PROVIDERS_API_URL = '/providers';

const providersService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${PROVIDERS_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getById(idempresa, idprovider) {
    try {
      const response = await axiosInstance.get(`${PROVIDERS_API_URL}/getById.php?idempresa=${idempresa}&idprovider=${idprovider}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter fornecedor por ID:', error);
      return [];
    }
  },

  async getForm(idempresa, idprovider) {
    try {
      const response = await axiosInstance.get(`${PROVIDERS_API_URL}/form.php?idempresa=${idempresa}&idprovider=${idprovider}`);
      return response.data !== "NOK" && Object.keys(response.data).length ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter formulário do fornecedor:', error);
      return {};
    }
  },

  async set(providerData) {
    try {
      const response = await axiosInstance.post(`${PROVIDERS_API_URL}/set.php`, providerData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa, idprovider) {
    try {
      const response = await axiosInstance.get(`${PROVIDERS_API_URL}/unset.php?idempresa=${idempresa}&idprovider=${idprovider}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover fornecedor:', error);
      throw error;
    }
  }
};

export default providersService;
